import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { AppService } from '@app/app.service';
import { AuthService } from '@app/auth/auth.service';

@Component({
  selector: 'app-edit-connection-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule,
    MatButtonModule,
  ],
  templateUrl: './edit-connection-dialog.component.html',
  styleUrl: './edit-connection-dialog.component.scss',
})
export class EditConnectionDialogComponent {
  form: FormGroup;
  emails: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditConnectionDialogComponent>,
    private fb: FormBuilder,
    private authService: AuthService,
    private appService: AppService
  ) {
    const user = this.authService.getUserFromStorage();

    this.emails = [
      user?.email,
      ...(user?.additional_emails || []).map((email: any) => email.email),
    ].filter(Boolean);

    this.form = this.fb.group({
      email: [
        data.connection.email || user?.email,
        [Validators.required, Validators.email],
      ],
    });
  }

  updateConnection() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.appService.patch(
      `user/carrier-connections/${this.data.connection.dot_number}`,
      this.form.value
    ).subscribe({
      next: (success) => {
        this.appService.showSnackBar(success.message, 'success');
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.appService.handleError(error);
      },
    });
  }
}